import { observer } from "mobx-react-lite";
import MainLayout from "../MainLayout";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { dialogStore } from "../../store/DialogStore";
import BTEmailEditor from "../../common/components/board/BTEmailEditor";
import { VerticalLayout } from "../../common/common-layout";
import { TitleLargeMedium, TitleMediumBold } from "../../common/common-text";
import BTBox from "../../common/components/BTBox";
import { sendRequestHomepageWork } from "../../service/HomepageService";


const RequestHomepageWork = () => {
    return (
        <MainLayout>
            <RequestHomepageWorkBody />
        </MainLayout>
    );
};

export default RequestHomepageWork;

const RequestHomepageWorkBody = observer(() => {
    const navigate = useNavigate();
    const [title, setTitle] = useState<string>("");
    const [contents, setContents] = useState<string>("");

    const handleSave = async () => {
        try {
            await sendRequestHomepageWork(title, contents);
            dialogStore.showDialog({
                title: "성공",
                message: "유지보수 업무 요청이 정상적으로 전송되었습니다.",
                onConfirm: () => navigate(-1)
            });
        } catch (error) {
            dialogStore.showDialog({
                title: "에러",
                message: "유지보수 업무 요청 전송 중 오류가 발생했습니다.",
                onConfirm: () => { }
            });
        }
    };

    return (
        <VerticalLayout height={'auto'} paddingLeft={36} paddingRight={36}>
            <TitleLargeMedium>홈페이지 유지보수 요청</TitleLargeMedium>
            <BTBox height='24px' />
            <VerticalLayout height={'auto'} paddingBottom={36}>
                <TitleMediumBold style={{ marginTop: "20px" }}>유지보수 요청 작성</TitleMediumBold>
                <BTBox height="16px" />
                <div style={{ width: '100%' }}>
                    <BTEmailEditor
                        title={title}
                        contents={contents}
                        setTitle={setTitle}
                        setContents={setContents}
                        onSave={handleSave}
                    />
                </div>
            </VerticalLayout>
        </VerticalLayout>

    );
});
